import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IListDto, IListResponseData, IPartnerCodeDetails, IPartnerCodesList, SERVICES_API } from '@pro-connect/shared';
import { map, Observable } from 'rxjs';
import { IAccountChangeAgreementsDto } from '../../models/account-change-agreements-dto';
import { IOrder } from './models/order';

@Injectable({
  providedIn: 'root',
})
export class MyDataService {
  constructor(
    @Inject(SERVICES_API)
    private readonly _servicesApi: string,
    private readonly _httpClient: HttpClient,
  ) {}

  /**
   * Change client agreement
   * @param dto Change agreement DTO
   */
  public changeClientAgreement(dto: IAccountChangeAgreementsDto): Observable<void> {
    return this._httpClient.post<void>(`${this._servicesApi}/pro/client/change-agreement`, dto, {
      withCredentials: true,
    });
  }

  /**
   * Generate a discount code for a logged client
   */
  public generateDiscountCode(): Observable<void> {
    return this._httpClient.post<void>(`${this._servicesApi}/pro/client/discount-code/generate`, null, {
      withCredentials: true,
    });
  }

  /**
   * Get a list of client discount codes
   * @param dto
   */
  public getClientDiscountCodes(dto: IListDto): Observable<IListResponseData<any>> {
    return this._httpClient.get<IListResponseData<any>>(`${this._servicesApi}/pro/client/discount-code/list`, {
      params: {
        ...dto,
      },
      withCredentials: true,
    });
  }

  /**
   * Get a list of client orders
   * @param dto
   */
  public getClientOrders(dto: IListDto): Observable<IListResponseData<IOrder>> {
    return this._httpClient.get<IListResponseData<IOrder>>(`${this._servicesApi}/pro/client/order/list`, {
      params: {
        ...dto,
      },
      withCredentials: true,
    });
  }

  /**
   * Get a list of partner codes
   */
  public getPartnerCodes(): Observable<IPartnerCodesList[]> {
    return this._httpClient
      .get<IListResponseData<IPartnerCodesList>>(`${this._servicesApi}/pro/cms/partner-code/list`, {
        params: {
          page: 1,
          perPage: 1000,
          sort: 'created_at',
          direction: 'desc',
        },
        withCredentials: true,
      })
      .pipe(map((response) => response.data));
  }

  /**
   * Get partner code details
   * @param id Partner code ID
   */
  public getPartnerCodeDetails(id: number): Observable<IPartnerCodeDetails> {
    return this._httpClient.get<IPartnerCodeDetails>(`${this._servicesApi}/pro/cms/partner-code/${id}/details`, {
      withCredentials: true,
    });
  }
}
